module.exports = __webpack_public_path__ + "img/resource-tech-image-41.999925cd.jpg";